'use strict';

import { newVueComponent, waitForDependencies } from '../../_imports/utils/utils.common';

const componentName = 'resource-banner';

waitForDependencies(() => {
    newVueComponent(componentName, () => require('./_imports/resource-banner.vue').default);
});
